import dynamic from "next/dynamic";

export const DynamicFooter002 = dynamic(() => import("./Footer002"), {
  suspense: true,
});
